import config from 'lib/config/config.common'

const getQuickBookingLink = function ( params ) {
    const { packageCode, sailDate, shipCode, locale, searchApplied, groupId = {} } = params;
    const quickBookPath = config.endpoints.quickBookApi;
    const { country, currency } = locale;
    const { adults, children } = searchApplied;
    const adultsParam = adults ? `&adults=${adults[0]}` : '';
    const childrenParam = adults && children ? `&children=${children[0]}` : '';

    return `${quickBookPath}?groupId=${groupId}&packageCode=${packageCode}&sailDate=${sailDate}&country=${country}&selectedCurrencyCode=${currency}&shipCode=${shipCode}${adultsParam}${childrenParam}`;
};

export default getQuickBookingLink;